import * as searchTypes from './searchFormType'
import useSearch from './useSearchForm'
import MyTextfield from '../../../../../control/textfield/textfield'
import Button from '../../../../../control/button/button'
import { Form } from 'react-final-form'
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MultiSelect from '../../../../../control/multiSelect/multiSelect'
import MyCheckbox from '../../../../../control/checkbox/checkbox'
import useTranslate from '../../../../../i18n/useTranslate'
import Collapse from '@material-ui/core/Collapse'
import React from 'react'

const hasAnyFilter = (v: any) =>
    !!(
        v?.status?.length ||
        v?.projectSubmitType?.length ||
        v?.submittedStatus?.length ||
        v?.submittedConsiderTypeId?.length ||
        v?.progressOverdue?.length ||
        v?.pendingAndRisk?.length
    )

const SearchView = (props: searchTypes.SearchViewType) => {
    const classes = useStyles({})
    const {
        onClickSubmit,
        onClickClearForm,
        handleEnterSearch,
        lutCategory,
        lutStatus,
        lutSubmissionProcess,
        isResearcher,
        isChairman,
        isOfficer,
        isCommittee,
        irb,
        initialValue = {},
        lutProjectTypes,
        lutPendingAndRisk,
        lutProgressOverdue,
    } = props
    const translate = useTranslate()

    const [advancedOpen, setAdvancedOpen] = React.useState<boolean>(
        Boolean(initialValue?.showAdvanced) || hasAnyFilter(initialValue),
    )

    let keywordSearchPlaceholder: string = `${translate.get('LABEL.PROJECT_NAME')}, ${translate.get(
        'LABEL.PROJECT_NUMBER',
    )}, ${translate.get('LABEL.COA_NO')}`
    if (!isResearcher) {
        keywordSearchPlaceholder += `, ${translate.get('LABEL.RESEARCHER_NAME')}`
    }

    const sanitize = (values: any) =>
        advancedOpen
            ? values
            : {
                  keywordSearch: values?.keywordSearch,
                  ...(isCommittee ? { doAndDoneCommentary: true } : {}),
              }

    React.useEffect(() => {
        setAdvancedOpen(Boolean(initialValue?.showAdvanced) || hasAnyFilter(initialValue))
    }, [initialValue])

    return (
        <Form
            onSubmit={(values) => onClickSubmit(sanitize(values))}
            initialValues={{
                ...initialValue,
            }}
        >
            {({ handleSubmit, form, values }) => {
                return (
                    <Grid container spacing={2} className={classes.root}>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="keywordSearch"
                                materialInputProps={{
                                    disabled: false,
                                    label: translate.get('LABEL.SEARCH_BY_KEYWORD'),
                                    placeholder: keywordSearchPlaceholder,
                                    size: 'small',
                                }}
                                onEnter={() => handleEnterSearch(values)}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={advancedOpen}
                                        onChange={(e) => setAdvancedOpen(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label={translate.get('LABEL.ADVANCED_SEARCH_FILTER')}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Collapse in={advancedOpen} timeout="auto" unmountOnExit>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <MultiSelect
                                            name="projectSubmitType"
                                            option={lutCategory}
                                            label={translate.get('LABEL.SUBMITTED_TYPE')}
                                            placeholder={translate.get('LABEL.SUBMITTED_TYPE')}
                                            defaultValue={initialValue?.projectSubmitType}
                                            isCheckedAll
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <MultiSelect
                                            name="status"
                                            option={lutStatus}
                                            label={translate.get('LABEL.STATUS_PROJECT')}
                                            placeholder={translate.get('LABEL.STATUS_PROJECT')}
                                            defaultValue={initialValue?.status}
                                            isCheckedAll
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <MultiSelect
                                            name="pendingAndRisk"
                                            option={lutPendingAndRisk}
                                            label={translate.get('LABEL.PENDING_AND_HIGH_RISK')}
                                            placeholder={translate.get('LABEL.PENDING_AND_HIGH_RISK')}
                                            defaultValue={initialValue?.pendingAndRisk}
                                            isCheckedAll
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <MultiSelect
                                            name="submittedConsiderTypeId"
                                            option={lutProjectTypes}
                                            label={translate.get('LABEL.PROJECT_TYPE')}
                                            placeholder={translate.get('LABEL.PROJECT_TYPE')}
                                            defaultValue={initialValue?.submittedConsiderTypeId}
                                            isCheckedAll
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <MultiSelect
                                            name="progressOverdue"
                                            option={lutProgressOverdue}
                                            label={translate.get('LABEL.PROGRESS_AND_OVERDUE')}
                                            placeholder={translate.get('LABEL.PROGRESS_AND_OVERDUE')}
                                            defaultValue={initialValue?.progressOverdue}
                                            isCheckedAll
                                        />
                                    </Grid>

                                    {!isResearcher && (
                                        <Grid item xs={12} md={6}>
                                            <MultiSelect
                                                name="submittedStatus"
                                                option={lutSubmissionProcess}
                                                label={translate.get('LABEL.SUBMISSION_PROCESS')}
                                                placeholder={translate.get('LABEL.SUBMISSION_PROCESS')}
                                                defaultValue={initialValue?.submittedStatus}
                                                isCheckedAll
                                            />
                                        </Grid>
                                    )}

                                    {isChairman && (
                                        <Grid item xs={12} md="auto">
                                            <MyCheckbox
                                                name="onlyMe"
                                                label={translate.get('LABEL.ONLY_ME')}
                                                onChangeValue={handleSubmit}
                                            />
                                        </Grid>
                                    )}
                                    {isChairman && irb == 2 && (
                                        <Grid item xs={12} md="auto">
                                            <MyCheckbox
                                                name="onlyPreliminary"
                                                label={translate.get('LABEL.ONLY_PRELIMINARY_REVIEWER')}
                                                onChangeValue={handleSubmit}
                                            />
                                        </Grid>
                                    )}
                                    {(isChairman || isOfficer) && (
                                        <Grid item xs={12} md="auto">
                                            <MyCheckbox
                                                name="researcherDraft"
                                                label={translate.get('LABEL.DISPLAY_DRAFT_PROJECTS')}
                                                onChangeValue={handleSubmit}
                                            />
                                        </Grid>
                                    )}
                                    {isCommittee && (
                                        <Grid item xs={12} md="auto">
                                            <MyCheckbox
                                                name="doAndDoneCommentary"
                                                label={translate.get('LABEL.DISPLAY_ALL_COMMENT_PROJECT')}
                                                onChangeValue={handleSubmit}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </Collapse>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justify="flex-end" spacing={2}>
                                <Grid item>
                                    <Button
                                        className={classes.btnSearch}
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        onClick={() => {
                                            onClickClearForm(form)
                                        }}
                                        color="default"
                                    >
                                        {translate.get('BUTTON.RESET')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        className={classes.btnSearch}
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        onClick={handleSubmit}
                                        color="primary"
                                    >
                                        {translate.get('BUTTON.SEARCH')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </Form>
    )
}

// Controller
const Search = (props: searchTypes.SearchType) => {
    const searchModel = useSearch(props)
    return <SearchView {...searchModel} {...props} />
}

export default Search

const useStyles = makeStyles((theme) => ({
    root: { padding: '15px' },
    btnSearch: {
        minWidth: '0px',
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))
